export const historyActionLabels = {
  baseline: 'Начальное состояние',
  created: 'Бронь создана',
  updated: 'Бронь изменена',
  cancelled: 'Бронь отменена',
  sale_created: 'Добавлена продажа',
  sale_cancelled: 'Продажа отменена',
}

export const historyFieldLabels = {
  resource_id: 'Объект, №',
  guest_name: 'Гость',
  guest_phone: 'Телефон',
  guest_email: 'Электронная почта',
  guests_count: 'Количество гостей',
  starts_at: 'Начало',
  ends_at: 'Окончание',
  status: 'Статус',
  notes: 'Комментарий',
  total_amount: 'Стоимость размещения',
  prepaid_amount: 'Предоплата за размещение',
  cancelled_at: 'Время отмены',
  sale_id: 'Продажа, №',
  sale_total: 'Сумма продажи',
  sale_amount: 'Сумма продажи',
  sale_total_amount: 'Сумма продажи',
  sale_lines: 'Позиции продажи',
}

export function bookingMoneyCents(value) {
  const text = String(value ?? '').trim()
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null
  const [whole, fraction = ''] = text.split('.')
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, '0'))
  return Number.isSafeInteger(cents) && cents <= 999999999999 ? cents : null
}

export function bookingPriceChanged(form, booking) {
  if (!booking) return false
  return ['totalAmount', 'prepaidAmount'].some((field) => (
    form[field] !== '' && form[field] != null
      && bookingMoneyCents(form[field]) !== bookingMoneyCents(booking[field] ?? 0)
  ))
}

export function formatHistoryMoney(value) {
  if (value == null || value === '') return '—'
  const number = Number(value)
  if (!Number.isFinite(number)) return '—'
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency', currency: 'RUB', minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(number)
}

export function historyValue(field, value) {
  if (value == null || value === '') return '—'
  if (['total_amount', 'prepaid_amount', 'sale_total', 'sale_amount', 'sale_total_amount'].includes(field)) {
    return formatHistoryMoney(value)
  }
  if (field === 'sale_lines' && Array.isArray(value)) {
    return value.map((line) => `${line.name || line.item_name || 'Позиция'} — ${line.quantity} × ${formatHistoryMoney(line.unit_price)}${line.catalog_unit_price != null && String(line.unit_price) !== String(line.catalog_unit_price) ? ` (по справочнику ${formatHistoryMoney(line.catalog_unit_price)})` : ''}`).join('\n')
  }
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function isPriceHistoryEntry(entry) {
  return Object.keys(entry?.changes || {}).some((field) => ['total_amount', 'prepaid_amount', 'sale_total', 'sale_amount', 'sale_total_amount', 'sale_lines'].includes(field))
}
